module.exports = __webpack_public_path__ + "static/img/sign-in.099876a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sign-in.png
// module id = vfSo
// module chunks = 0